import { createStore, applyMiddleware, compose } from "redux";
import { save as onSaveBlueprint, updateConstructs } from "./blueprint/actions";
import logger from "redux-logger";
import thunk from "redux-thunk";
import rootReducer from "./root-reducer";
import watch from 'redux-watch';
import { getDuplicates, removeDuplicates, checkDuplicateNonEmpty } from '../services/entities/common';

const middlewares = [thunk];

if (process.env.NODE_ENV === "development") {
	middlewares.push(logger);
}

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(rootReducer, composeEnhancer(applyMiddleware(...middlewares)));

let w = watch(store.getState, 'undoredo.undo')
store.subscribe(w((newVal, oldVal, objectPath) => {
	// console.log('%s changed from %s to %s', objectPath, oldVal, newVal)
	const blueprintId = store.getState().global.details.id;
	const savingInProgress = store.getState().global.savingInProgress;
	const constructs = store.getState().constructs;
	const undo = store.getState().undoredo.undo;
	const redo = store.getState().undoredo.redo;

	const duplicates = getDuplicates(constructs);
	const isDuplicateNonEmpty = checkDuplicateNonEmpty(duplicates);

	if (isDuplicateNonEmpty) {
		const sanitizedConstructs = removeDuplicates(constructs, duplicates);
		const { ...rest } = sanitizedConstructs;

		store.dispatch(updateConstructs(rest));
	}
	
	if (blueprintId !== "" && blueprintId !== null && savingInProgress === false  && !(undo.length === 0 && redo.length === 0)) {
		setTimeout(() => { store.dispatch(onSaveBlueprint({ autoSave: true, stateChangeListener: true })) }, 1000)
	}


}))

export default store;
